import { render } from "./menu5.vue?vue&type=template&id=cb068682&scoped=true"
import script from "./menu5.vue?vue&type=script&lang=js"
export * from "./menu5.vue?vue&type=script&lang=js"

import "./menu5.vue?vue&type=style&index=0&id=cb068682&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb068682"]])

export default __exports__